<template>
  <!-- Newsletter Start -->
  <div id="footertwo" class="container-fluid newsletter py-4">
    <div class="container text-center">
      <div class="row g-5 align-items-center justify-content-center">
        <div
          class="col-sm ps-lg-0 pt-5 pt-md-0 text-start wow fadeIn"
          data-wow-delay="0.3s"
          v-for="(item, index) in info.children"
          :key="index"
        >
          <div
            class="d-flex align-items-center justify-content-center f-two-item"
          >
            <div class="f-two-item-img">
              <i :class="'blue img lni lni-' + item.iconUrl"></i>
              <!-- {{ item.iconUrl }} xxx
              <img class="p-3" :src="item.iconUrl" alt="" /> -->
            </div>
            <div>
              <div>{{ item.title }}</div>
              <div style="width:100%" v-html="item.description"></div>
            </div>
          </div>
        </div>

        <!-- <div class="col-sm ps-lg-0 pt-5 pt-md-0 text-start wow fadeIn" data-wow-delay="0.3s">
          <div class="d-flex align-items-center justify-content-md-start justify-content-lg-center f-two-item">
            <div class="f-two-item-img">
              <img class="p-3" src="@/assets/hhdimg/footer2.png" alt="">
            </div>
            <div>
              <div>sky@hhdlink.com</div>
            </div>
          </div>
        </div>

        <div class="col-sm ps-lg-0 pt-5 pt-md-0 text-start wow fadeIn" data-wow-delay="0.3s">
          <div class="d-flex align-items-center justify-content-lg-end f-two-item">
            <div class="f-two-item-img">
              <img class="p-3" src="@/assets/hhdimg/footer3.png" alt="">
            </div>
             <div class="f-two-item-text">
                  9F,Bldg.A,Jingang Tech Park,Fuhai Street,Baoan District,Shenzhen
             </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <!-- Newsletter End -->
</template>
<script>
import { homePage } from "@/api/modules/home";
export default {
  name: "Footertwo",
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      let data = {
        page: 0,
        moduleType: 6,
        language: this.$store.getters.lang,
      };
      homePage(data).then((res) => {
        if (res.returnCode == 200 && res.data.length > 0) {
          res.data[0].children = res.data[0].children.map((ite) => {
            let str = "";
            if (ite.description) {
              str = ite.description.replaceAll("\n", "</br>");
            }
            return {
              ...ite,
              description: str,
            };
          });
          this.info = res.data[0];
        }
      });
    },
  },
};
</script>

<style scoped>
/*** Newsletter ***/
.blue {
  color: #0c74b5;
  font-size: 22px;
}
.newsletter {
  background: url("../assets/hhdimg/bg-hero.png") center center no-repeat;
  background-size: cover;
  background-color: #0c74b5;
}

.f-two-item {
  color: #fff;
}

.f-two-item-img {
  width: 70px !important;
  height: 70px;
  background-color: #fff;
  border-radius: 50%;
  /* padding: 5px; */
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.f-two-item-img img {
  width: 70px;
  height: 70px;
}
.f-two-item-text {
  width: 250px;
  word-wrap: break-word;
}
/*  @media (min-width: 992px) {
    .newsletter .container {
      max-width: 100% !important;
    }

    .newsletter .newsletter-text {
      padding-right: calc(((100% - 960px) / 2) + .75rem);
    }
  }

  @media (min-width: 1200px) {
    .newsletter .newsletter-text {
      padding-right: calc(((100% - 1140px) / 2) + .75rem);
    }
  }

  @media (min-width: 1400px) {
    .newsletter .newsletter-text {
      padding-right: calc(((100% - 1320px) / 2) + .75rem);
    }
  } */
</style>



// WEBPACK FOOTER //
// src/components/Footertwo.vue